import React from "react";
import Selector from "./screens/selector";
import Header from "./screens/header";
import Table from "./screens/table";

function App(): JSX.Element {
  return (
    <div className="container-fluid mx-0" style={{ width: "1150px" }}>
      <Header />
      <Selector />
      <Table />
    </div>
  );
}

export default App;
